/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Feature } from './Feature';
import {
    FeatureFromJSON,
    FeatureFromJSONTyped,
    FeatureToJSON,
} from './Feature';

/**
 * Group of features (Feature Pack)
 * @export
 * @interface FeaturePack
 */
export interface FeaturePack {
    /**
     * Feature Pack name
     * @type {string}
     * @memberof FeaturePack
     */
    name?: string;
    /**
     * List of features
     * @type {Array<Feature>}
     * @memberof FeaturePack
     */
    features?: Array<Feature>;
}

/**
 * Check if a given object implements the FeaturePack interface.
 */
export function instanceOfFeaturePack(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FeaturePackFromJSON(json: any): FeaturePack {
    return FeaturePackFromJSONTyped(json, false);
}

export function FeaturePackFromJSONTyped(json: any, ignoreDiscriminator: boolean): FeaturePack {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'features': !exists(json, 'features') ? undefined : ((json['features'] as Array<any>).map(FeatureFromJSON)),
    };
}

export function FeaturePackToJSON(value?: FeaturePack | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'features': value.features === undefined ? undefined : ((value.features as Array<any>).map(FeatureToJSON)),
    };
}

